

module.exports = __webpack_require__.stylable.create(
    "Calendar3146997461",
    {"classes":{"root":"Calendar3146997461__root","DesktopControllers":"Calendar3146997461__DesktopControllers","Children":"Calendar3146997461__Children","MobileManu":"Calendar3146997461__MobileManu"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size:'16px', lineHeight: '1.4em'}\"","BackgroundColor":"\"fallback(color(--calendarBackgroundColor), fallback(color(--bgBoxColor), color(color-1)))\"","HeaderColor":"\"fallback(color(--headerFontColor), fallback(color(--daysColor), color(color-5)))\"","HeaderFont":"\"fallback(font(--headerFont), font({theme: 'Body-M', size:'16px', lineHeight: '1.4em'}))\""},"keyframes":{}},
    "",
    19,
    "Calendar3146997461",
    null
);
